import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import SidePanelItem from './Item';

import styles from './SidePanel.module.scss';

interface Tab {
  label: string;
  href: string;
}

interface Props {
  tabs: Tab[];
}

const getSelectedTab = (tabs: Tab[]) => {
  for (let i = 0; i < tabs.length; i += 1) {
    const tab = tabs[i];

    if (document.location.pathname.startsWith(tab.href)) {
      return tab.label;
    }
  }

  return '';
};

const SidePanel = ({ tabs }: Props) => {
  useRouteMatch();
  const selectedTab = getSelectedTab(tabs);

  return (
    <div className={styles.side_panel}>
      {tabs.map(({ label, href }) => (
        <SidePanelItem
          key={label}
          label={label}
          href={href}
          selected={label === selectedTab}
        />
      ))}
    </div>
  );
};

export default SidePanel;
